import { useAppStore } from '@S/appStore';
import { useTheme } from 'vuetify';

export const useBackgroundStyle = () => {
    const theme = useTheme();

    return computed(() => {
        const store = useAppStore();
        return `background-color: rgba(${theme.global.name.value === 'light' ? '255, 255, 255' : '16, 16, 16'}, ${store.deviceType === 'Desktop' ? theme.global.name.value === 'light' ? .95 : .8 : 1});
        transition: background-color .15s ease, backdrop-filter .15s ease;
        ${store.deviceType === 'Desktop' ? 'backdrop-filter: blur(5px) saturate(250%);' : ''}`;
    });
};
